import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

// Import modals
import AddHomeworkModal from "../modals/AddHomeworkModal";
import EditHomeworkModal from "../modals/EditHomeworkModal";

const ManageHomework = () => {
  const routes = all_routes;
  const [selectedClass, setSelectedClass] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [selectedHomework, setSelectedHomework] = useState<any>(null);

  // Mock data for testing
  const mockClasses = [
    { id: 1, name: "Grade 10A - Mathematics", students: 30 },
    { id: 2, name: "Grade 11B - Physics", students: 28 },
    { id: 3, name: "Grade 9C - Mathematics", students: 32 },
  ];

  const mockHomework = [
    {
      id: 1,
      title: "Algebra Practice Problems",
      class: "Grade 10A - Mathematics",
      assignedDate: "2024-07-15",
      dueDate: "2024-07-22",
      status: "Active",
      submitted: 22,
      total: 30,
      description: "Complete exercises 1-20 from Chapter 5",
    },
    {
      id: 2,
      title: "Physics Lab Report",
      class: "Grade 11B - Physics",
      assignedDate: "2024-07-10",
      dueDate: "2024-07-20",
      status: "Due Soon",
      submitted: 15,
      total: 28,
      description: "Submit lab report on pendulum experiment",
    },
    {
      id: 3,
      title: "Geometry Worksheets",
      class: "Grade 9C - Mathematics",
      assignedDate: "2024-07-08",
      dueDate: "2024-07-18",
      status: "Overdue",
      submitted: 25,
      total: 32,
      description: "Complete worksheets on triangles and angles",
    },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Active":
        return "badge-soft-success";
      case "Due Soon":
        return "badge-soft-warning";
      case "Overdue":
        return "badge-soft-danger";
      case "Completed":
        return "badge-soft-primary";
      default:
        return "badge-soft-secondary";
    }
  };

  const filteredHomework = mockHomework.filter((hw) => {
    const statusMatch = filterStatus === "all" || hw.status === filterStatus;
    return statusMatch;
  });

  const handleEditHomework = (homework: any) => {
    setSelectedHomework(homework);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherDashboard}>Teacher Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Manage Homework</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="row">
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-primary-transparent me-3">
                      <i className="ti ti-book"></i>
                    </div>
                    <div>
                      <h4>{mockHomework.length}</h4>
                      <p className="text-muted mb-0">Total Assignments</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-success-transparent me-3">
                      <i className="ti ti-check"></i>
                    </div>
                    <div>
                      <h4>
                        {
                          mockHomework.filter((hw) => hw.status === "Active")
                            .length
                        }
                      </h4>
                      <p className="text-muted mb-0">Active</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-warning-transparent me-3">
                      <i className="ti ti-clock"></i>
                    </div>
                    <div>
                      <h4>
                        {
                          mockHomework.filter((hw) => hw.status === "Due Soon")
                            .length
                        }
                      </h4>
                      <p className="text-muted mb-0">Due Soon</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-danger-transparent me-3">
                      <i className="ti ti-alert-triangle"></i>
                    </div>
                    <div>
                      <h4>
                        {
                          mockHomework.filter((hw) => hw.status === "Overdue")
                            .length
                        }
                      </h4>
                      <p className="text-muted mb-0">Overdue</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Homework Management</h4>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#addHomeworkModal"
                    >
                      <i className="ti ti-plus me-1"></i>Create Assignment
                    </button>
                    <button className="btn btn-outline-primary btn-sm">
                      <i className="ti ti-download me-1"></i>Export
                    </button>
                  </div>
                </div>

                {/* Filters */}
                <div className="card-body border-bottom">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Search Homework</label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ti ti-search"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by title, class..."
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Filter by Class</label>
                      <select
                        className="form-select"
                        value={selectedClass}
                        onChange={(e) => setSelectedClass(e.target.value)}
                      >
                        <option value="">All Classes</option>
                        {mockClasses.map((cls) => (
                          <option key={cls.id} value={cls.name}>
                            {cls.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Filter by Status</label>
                      <select
                        className="form-select"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                      >
                        <option value="all">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Due Soon">Due Soon</option>
                        <option value="Overdue">Overdue</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">&nbsp;</label>
                      <button className="btn btn-outline-secondary w-100">
                        <i className="ti ti-filter me-1"></i>Reset
                      </button>
                    </div>
                  </div>
                </div>

                {/* TODO Placeholders */}
                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6>
                      <i className="ti ti-info-circle me-2"></i>TODO: Connect to
                      homework API
                    </h6>
                    <ul className="mb-0">
                      <li>Create/Edit/Delete homework assignments</li>
                      <li>Track student submissions and progress</li>
                      <li>Grade assignments and provide feedback</li>
                      <li>Send notifications to students/parents</li>
                    </ul>
                  </div>
                </div>

                {/* Homework Table */}
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Assignment</th>
                          <th>Class</th>
                          <th>Assigned Date</th>
                          <th>Due Date</th>
                          <th>Status</th>
                          <th>Progress</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredHomework.map((homework) => (
                          <tr key={homework.id}>
                            <td>
                              <div>
                                <h6 className="mb-1">{homework.title}</h6>
                                <small className="text-muted">
                                  {homework.description}
                                </small>
                              </div>
                            </td>
                            <td>{homework.class}</td>
                            <td>{homework.assignedDate}</td>
                            <td>{homework.dueDate}</td>
                            <td>
                              <span
                                className={`badge ${getStatusColor(
                                  homework.status
                                )}`}
                              >
                                {homework.status}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div
                                  className="progress me-2"
                                  style={{ width: "60px", height: "6px" }}
                                >
                                  <div
                                    className="progress-bar bg-success"
                                    style={{
                                      width: `${
                                        (homework.submitted / homework.total) *
                                        100
                                      }%`,
                                    }}
                                  ></div>
                                </div>
                                <small>
                                  {homework.submitted}/{homework.total}
                                </small>
                              </div>
                            </td>
                            <td>
                              <div className="dropdown">
                                <button
                                  className="btn btn-white btn-sm dropdown-toggle"
                                  data-bs-toggle="dropdown"
                                >
                                  Actions
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <button className="dropdown-item">
                                      <i className="ti ti-eye me-2"></i>View
                                      Details
                                    </button>
                                  </li>
                                  <li>
                                    <button className="dropdown-item">
                                      <i className="ti ti-users me-2"></i>View
                                      Submissions
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      className="dropdown-item"
                                      data-bs-toggle="modal"
                                      data-bs-target="#editHomeworkModal"
                                      onClick={() =>
                                        handleEditHomework(homework)
                                      }
                                    >
                                      <i className="ti ti-edit me-2"></i>Edit
                                      Assignment
                                    </button>
                                  </li>
                                  <li>
                                    <hr className="dropdown-divider" />
                                  </li>
                                  <li>
                                    <button className="dropdown-item">
                                      <i className="ti ti-bell me-2"></i>Send
                                      Reminder
                                    </button>
                                  </li>
                                  <li>
                                    <button className="dropdown-item text-danger">
                                      <i className="ti ti-trash me-2"></i>Delete
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <AddHomeworkModal />
      <EditHomeworkModal homeworkId={selectedHomework} />
    </>
  );
};

export default ManageHomework;
